import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportUpdateTableContentHelper {
  updateTableContent=new Subject<updateBody>();
  //update table columns and headers
  pushTableContent(body:updateBody){
    this.updateTableContent.next(body);
  }
  //get updated data
  getTableContentData():Observable<updateBody>{
    return this.updateTableContent;
  }
}
interface updateBody {
  tableColumns: string[]
  displayTableColumns:{[key:string]:string}
}